import React from 'react';

import { flagStyles } from '../settings';

const SvgHM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2256px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgHM;
